export const handleFormatValue = (value: string): number | null => {
  const parsedValue = parseFloat(value)
  return isNaN(parsedValue) ? null : parsedValue
}
